import { AVAILABLE } from './constants/expertAvailability';
import * as tabs from 'constants/tabNames';
import { INITIAL_CONVERSATION_RATINGS_STATE } from 'constants/conversationRatingInitialState';
import { TICKET_STATUS_FILTER } from 'constants/ticketStatuses';

export const initialSelectedTicketStatus = TICKET_STATUS_FILTER.all;

export const expertsInitialState = {
  idsToExperts: {},
};

export const defaultSelectedExpertStateForwardingDropdown = {
  id: null,
  name: 'Any Expert',
};

export const forwardingDropdownInitialState = {
  searchParam: '',
  selectedExpert: defaultSelectedExpertStateForwardingDropdown,
  all: {},
  pagination: {
    idList: [],
    nextPage: 0,
    loadLimit: 20,
    full: false,
    cursor: null,
  },
};

export const initialMLDataState = {
  ordersIds: {},
};

const INITIAL_STATE = {
  liveQueryStarted: false,
  user: {
    isAdmin: false,
    isAccountUser: false,
    firstName: '',
    availability: AVAILABLE,
    mfaToken: '',
    phoneNumberLastDigits: '',
  },
  experts: expertsInitialState,
  forwardToExpert: forwardingDropdownInitialState,
  selectedTicketStatus: initialSelectedTicketStatus,
  conversation: { allMessages: [], selectedConversationId: '' },
  selectedTicketId: '',
  previousSelectedTicketId: {
    [tabs.NOMINATED]: '',
    [tabs.LIVE_CHAT]: '',
    [tabs.ASSIGNED]: '',
    [tabs.ALL]: '',
  },
  lockedConversationId: '',
  tools: {
    general: {
      selectedTool: 'ACTIONS',
      searchType: null,
      toolDomains: {},
      selectedToolDomains: {},
    },
    zendesk: {
      currentPage: '',
      categories: [],
      sections: [],
      articles: [],
      users: {},
      articleSearchResults: [],
      selectedArticle: null,
    },
  },
  // kb initial state defined in reducers/kb.js
  ui: {
    loading: { isLoading: true, component: 'inbox', message: '' },
    messages: {
      selectedInboxTab: 'nominated',
    },
    tools: {
      general: {
        showTools: false,
      },
    },
    display: {
      ticketRemovalInProcess: [],
    },
    conversationRatings: { ...INITIAL_CONVERSATION_RATINGS_STATE },
    userSettings: {
      debugModeEnabled: false,
    },
  },
  mlData: initialMLDataState,
};

export default INITIAL_STATE;
